import { ChangeEvent, FC } from 'react';
import { useAppSelector } from '@redux/store';
import { debounce } from 'lodash';

import SearchInput from '@3.0/Forms/SearchInput/SearchInput';
import { INGESTION_BY_DATA_SOURCE_TEXT } from '../IngestionByDataSource.constants';

type TProps = {
  setSearchTerm: (term: string) => void;
};

const DataSourcesMenuBarLabel: FC<TProps> = ({ setSearchTerm }) => {
  const view = useAppSelector((state) => state.ingestionDataSourceList.view);
  const selectedDataSource = useAppSelector(
    (state) => state.ingestionDataSourceList.selectedDataSource
  );

  const handleSearchTermChange = debounce((e: ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  }, 300);

  return (
    <div className="tw:w-full tw:flex tw:flex-row tw:items-center tw:justify-between tw:shrink-0">
      <span>
        {view === 'dataSources'
          ? INGESTION_BY_DATA_SOURCE_TEXT.toolbarText.dataSources
          : INGESTION_BY_DATA_SOURCE_TEXT.toolbarText.tables?.[
              selectedDataSource?.dataSourceType as keyof typeof INGESTION_BY_DATA_SOURCE_TEXT.toolbarText.tables
            ] || ''}
      </span>
      <SearchInput
        animated
        label=""
        variant="inverse"
        onClear={() => setSearchTerm('')}
        inputProps={{
          id: 'ingestionSearchInput',
          onChange: handleSearchTermChange,
          style: { width: 300 },
        }}
      />
    </div>
  );
};

export default DataSourcesMenuBarLabel;
